export default "__VITE_ASSET__BmydHVD5__"